import React from 'react';
import { UserInfo } from '@typings/user';
import style from './style.scss';

interface Props {
  user: UserInfo;
}

export default function Author(props: Props) {
  const { user } = props;
  return (
    <div className={style.author}>
      <img className={style.avatar} src={user.avatar_url} />
      <span className={style.name}>{user.name}</span>
    </div>
  );
}
